// components/BackButton.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../css/BackButton.css";

const BackButton = ({ inline = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/restaurantes") return null;

  return (
    <button
      className={`back-button ${inline ? "inline" : "floating"}`}
      onClick={() => navigate(-1)}
    >
      <FaArrowLeft /> Voltar
    </button>
  );
};

export default BackButton;
